export default {
    inject: ['EventBus'],
    props: {
        ariaLabel: {
            type: String,
            required: false
        }
    },
    render(h) {
        const container = h(
            'button', {
                attrs: {
                    'aria-label': this.ariaLabel
                },
                on: {
                    click: (evt) => {
                        if(evt.target.hasAttribute('step-index')) {
                            this.EventBus.$emit('stepTrigger', evt.target.getAttribute('step-index'));
                        } else {
                            const eventName = evt.target.getAttribute('data-eventname');
                            const eventparameters = evt.target.getAttribute('data-eventparameters');
                            const eventSendTo = evt.target.getAttribute('data-send-to');
                            if(eventName && eventparameters) {
                                const rawObject = eventparameters.split(',').map(i => (i.split(':')).map(j => j.trim()));
                                const eventObject = Object.fromEntries(rawObject);
                                const eventNewObj = {};
                                for (const key in eventObject) {
                                    const newKey = (key.replace(/\s/g, '_')).toLowerCase();
                                    eventNewObj[newKey] = eventObject[key];
                                }
                                eventNewObj.send_to = eventSendTo;
                                window.gtag('event', eventName, eventNewObj);
                            }
                            this.EventBus.$emit('stepTrigger');
                            // evt.target.setAttribute('disabled', 'disabled');
                        }
                    }
                }
            }, [this.$slots.default]
        );

        return container;
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-transition-trigger.js